module.exports = __webpack_public_path__ + "static/media/star-empty.f3820c7a.svg";